module.exports = __webpack_public_path__ + "static/media/yonder_rt.b037b064.jpg";